/* eslint-disable max-len */
import React from 'react';
import { Icon } from '../../concepts/resources/Icon';
import { HeaderButton } from '../../ui/HeaderButton';
import { Tip } from '../../ui/Tip';
import { useResolve } from '../Container';
import { PopupManager } from '../popups/PopupManager';
import { preferencesPopup } from '../profile/PreferencesPopup';

export const PreferencesButton = ({ }) => {

    const popups = useResolve(PopupManager);

    const onOpenPreferences = () => {
        popups.invoke(preferencesPopup());
    };

    return <Tip text="Preferences" position="bottom">
        <HeaderButton data-action="header.openPreferences" onClick={onOpenPreferences}>
            <Icon size="1.5" src="deqo://icons/deqo/cog" />
        </HeaderButton>
    </Tip>;
};
